var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sui-popup',{attrs:{"content":"Newly updated! First come, First serve!","size":"mini"}},[_c('div',{staticClass:"job-sticker",attrs:{"slot":"trigger"},slot:"trigger"},[_vm._v("New!")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }